import react from "react";

const GuidesList = (props) => {

    const formattedDate = (createdAt) => new Date(createdAt).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
    });

    return (
        <div>
            {props.guides.length === 0 ? (
                <p>No guides found.</p>
            ) : (
                <ul className="admin-ul">
                    <h3>Guides</h3>
                    <li className="list-item header"> 
                            <div>
                                <p>Guide</p>
                                <p>Created</p>
                            </div>
                    </li>
                    {props.guides.map((guide) => (
                        <li className="list-item form-group inline" key={guide._id} onClick={() => props.showGuideDetails(guide)}>
                            <div>{guide.name}</div>
                            <div>
                                {`${formattedDate(guide.createdAt)}`}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default GuidesList;